export default __webpack_public_path__ + "static/media/img (3).f41fb0c5.jpg";